import { Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

interface HeaderTextComponentProps {
  variant: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  children: ReactNode;
}

const headerTextComponent: FC<HeaderTextComponentProps> = ({
  variant,
  children,
}) => {
  return (
    <Typography
      variant={variant}
      sx={{
        fontStyle: 'normal',
        lineHeight: '125%',
        fontWeight: '400',
        fontSize: () => {
          switch (variant) {
            case 'h1':
              return '22px';
            case 'h2':
              return '20px';
            case 'h3':
              return '18px';
            case 'h4':
              return '16px';
            case 'h5':
              return '14px';
            case 'h6':
              return '12px';
            default:
              return 'inherit';
          }
        },
      }}
    >
      {children}
    </Typography>
  );
};

export default headerTextComponent;
